/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modify_Clock_Times_HelpInputs */

const en_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The timing will be adjusted based on the difference between the source and target Frame Rates`)
};

const fr_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le minutage sera ajusté selon la différence entre les fréquences d’images source et cible`)
};

const de_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zeitsteuerung wird anhand der Differenz zwischen Quell- und Zielbildrate angepasst.`)
};

const it_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La temporizzazione verrà regolata in base alla differenza tra i frame rate di origine e di destinazione`)
};

const ru_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время будет скорректировано в зависимости от разницы между исходной и целевой частотой кадров.`)
};

const es_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tiempo se ajustará en función de la diferencia entre las velocidades de fotogramas de origen y destino.`)
};

const zh_cn2_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间调整将根据源帧速率和目标帧速率之间的差异进行。`)
};

const ja_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングはソースとターゲットのフレームレートの差に基づいて調整されます。`)
};

const hi_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत और लक्ष्य फ्रेम दरों के बीच के अंतर के आधार पर समय को समायोजित किया जाएगा।`)
};

const pt_pt2_modify_clock_times_help = /** @type {(inputs: Modify_Clock_Times_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tempo será ajustado com base na diferença entre as taxas de quadros de origem e de destino.`)
};

/**
* | output |
* | --- |
* | "The timing will be adjusted based on the difference between the source and target Frame Rates" |
*
* @param {Modify_Clock_Times_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const modify_clock_times_help = /** @type {((inputs?: Modify_Clock_Times_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modify_Clock_Times_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_modify_clock_times_help(inputs)
	if (locale === "de") return de_modify_clock_times_help(inputs)
	if (locale === "it") return it_modify_clock_times_help(inputs)
	if (locale === "ru") return ru_modify_clock_times_help(inputs)
	if (locale === "es") return es_modify_clock_times_help(inputs)
	if (locale === "zh-CN") return zh_cn2_modify_clock_times_help(inputs)
	if (locale === "ja") return ja_modify_clock_times_help(inputs)
	if (locale === "hi") return hi_modify_clock_times_help(inputs)
	if (locale === "pt-PT") return pt_pt2_modify_clock_times_help(inputs)
	return en_modify_clock_times_help(inputs)
});